// extracted by mini-css-extract-plugin
export default {"btn":"TrendViewToolbar_btn__yqIIs","trendTime":"TrendViewToolbar_trendTime__m7nf-","active":"TrendViewToolbar_active__HrXul"};